<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/siUSt7/images/cover.jpg?1706354131840" alt="This image is the cover for the book German Armour Lost on the Western Front, Images of War"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">German Armour Lost on the Western Front, Images of War
      </h1>
      <p class="bookDescription body article font2">
        <b>An illustrated history of Nazi German armoured vehicles destroyed in action along the Western Front during World War II.</b><br/><br/>The German armoured forces lost some 10,000 armoured fighting vehicles. Today there are very few surviving vehicles from the Wehrmacht. We are fortunate therefore that these unique photographs detail the fate of the Panzers destroyed in action in the west.<br/><br/><b>Praise for <i>German Armour Lost on the Western Front</i></b><br/><br/><b>“A marvellous collection of over 200 photographs of German armoured vehicles knocked out from 1944 onwards, from the Normandy beaches and Italy to the borders of the Reich. Almost all of the vehicles featured are those built around the Panzer III to VI chassis, including self-propelled guns and many specific variants of tanks. . . . With this broad array of vehicles and situations, this book will certainly be an invaluable guide to the modeller, but it also serves as a reminder of the devastating impact of armour piercing weapons, and the vulnerability of tank crews in their seemingly impervious machines.” —Pegasus Archive, Mark Hickman</b><br/><br/><b>“An excellent pictograph reference book covering German losses during the Second World War. The pictures are clear and the supporting text provided, factual. I highly recommend this book to any historical buffs or modeling fans who are interested in wrecked and abandoned vehicles.” —MSC Review Connect, Todd Michalak</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bob Carruthers
      </h2>
      
      <p class="authorDescription body article">Bob Carruthers is an Emmy Award winning author and historian, who has written extensively on the Great War. A graduate of Edinburgh University, Bob is the author of a number of military history titles including the Amazon best seller The Wehrmacht in Russia.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0827d33c